<template>
  <el-dialog
    v-model="dialogFormVisible"
    :close-on-click-modal="false"
    title="修改密码"
    width="600px"
    @close="close"
  >
    <el-form
      ref="form"
      class="demo-form"
      :label-position="labelPosition"
      label-width="100px"
      :model="form"
      :rules="rules"
    >
      <el-form-item label="旧密码" prop="oldPassword">
        <el-input
          v-model.trim="form.oldPassword"
          show-password
          placeholder="请输入旧密码"
        />
      </el-form-item>
      <el-form-item label="新密码" prop="password">
        <el-input
          v-model.trim="form.password"
          show-password
          placeholder="请输入新密码"
        />
      </el-form-item>
      <el-form-item label="确认新密码" prop="submitPassword">
        <el-input
          v-model.trim="form.submitPassword"
          show-password
          placeholder="请输入确认新密码"
        />
      </el-form-item>      
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </template>
  </el-dialog>
</template>
<script>
import { changePassword } from '@/api/settings'
export default {
  name: 'ChangePwd',
  data() {
    return {
      labelPosition: 'right',
      form: {
        oldPassword: '',
        password: '',
        submitPassword: '',
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
        ],
        submitPassword: [
          { required: true, message: '请输入确认新密码', trigger: 'blur' },
        ],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    showChangePWD() {
      this.dialogFormVisible = true
    },
    submitForm() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          if(this.form.password==this.form.submitPassword) {
          this.$baseConfirm(`你确定要修改密码吗`, null, async () => {
            await changePassword({
              ...this.form,
            })
            this.close()
            // this.dialogFormVisible = false
            this.$message.warning('修改密码成功')
          })
          }else {
            this.$message.warning('请确保两次输入的新密码相同')
          }
        } else {
          this.$message.warning('请填写密码信息')
          return false
        }
      })
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
  },
}
</script>
